import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 19v-14h6a3 3 0 0 1 0 6h-8","key":"svg-0"}],["path",{"d":"M14 15h-8","key":"svg-1"}]]

/**
 * IconCurrencyRubel
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY3VycmVuY3ktcnViZWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTggMTl2LTE0aDZhMyAzIDAgMCAxIDAgNmgtOCIgLz4KICA8cGF0aCBkPSJNMTQgMTVoLTgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/currency-rubel
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCurrencyRubel = createReactComponent('outline', 'currency-rubel', 'CurrencyRubel', __iconNode);

export default IconCurrencyRubel;